import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Clock, Layers } from "lucide-react";
import client from "../lib/api";
import SEO from "../components/SEO";
import Divider from "../components/Divider";
import { Reveal } from "../components/Reveal";

const FILTERS = [
  { key: "tutti", label: "Tutti" },
  { key: "disponibile", label: "Disponibili" },
  { key: "in_arrivo", label: "In arrivo" },
  { key: "horeca", label: "Per professionisti Horeca" },
];

export default function Corsi() {
  const [courses, setCourses] = useState([]);
  const [filter, setFilter] = useState("tutti");

  useEffect(() => {
    client.get("/courses").then((r) => setCourses(r.data)).catch(() => {});
  }, []);

  const filtered = courses.filter((c) => {
    if (filter === "tutti") return true;
    if (filter === "horeca") return c.horeca;
    return c.status === filter;
  });

  return (
    <div data-testid="corsi-page">
      <SEO title="Corsi di vino online" path="/corsi"
           description="Corsi di vino online per principianti, appassionati e professionisti Horeca. Dal corso base alla vendita, con Stefano Cremonese." />
      <section className="bg-nero pt-40 pb-20 grain relative">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 text-center">
          <Reveal>
            <p className="text-oro text-xs uppercase tracking-[0.35em] mb-4">L'ecosistema formativo</p>
            <h1 className="font-serif text-4xl sm:text-5xl font-bold text-panna">I Corsi</h1>
            <p className="mt-6 text-panna/70 max-w-2xl mx-auto leading-relaxed">
              Percorsi per ogni livello: dal primo calice alla vendita professionale in sala.
              Impara il vino da chi lo vende ogni giorno, senza snobismi.
            </p>
            <Divider light className="mt-10" />
          </Reveal>
        </div>
      </section>

      <section className="bg-panna py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="flex flex-wrap gap-3 mb-14 justify-center" data-testid="course-filters">
            {FILTERS.map((f) => (
              <button key={f.key} data-testid={`filter-${f.key}`} onClick={() => setFilter(f.key)}
                      className={`rounded-full px-5 py-2.5 text-sm font-medium transition-all duration-300 border ${
                        filter === f.key
                          ? "bg-bordeaux text-panna border-bordeaux"
                          : "border-nero/20 text-nero/70 hover:border-bordeaux/50 hover:text-bordeaux"
                      }`}>
                {f.label}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {filtered.map((c, i) => (
              <Reveal key={c.id} delay={(i % 3) * 0.1}>
                <Link to={`/corsi/${c.slug}`} data-testid={`course-card-${c.slug}`}
                      className="group flex flex-col h-full rounded-2xl border border-nero/10 bg-panna-dark/40 overflow-hidden transition-all duration-500 hover:border-bordeaux/30 hover:-translate-y-1.5 hover:shadow-xl">
                  <div className="bg-nero p-8 flex items-center justify-between">
                    <GraduationCap size={26} className="text-oro" />
                    <span className={`text-[0.65rem] uppercase tracking-[0.2em] px-3 py-1.5 rounded-full ${
                      c.status === "disponibile" ? "bg-oliva/20 text-oliva border border-oliva/40" : "bg-oro/10 text-oro border border-oro/30"
                    }`}>
                      {c.status === "disponibile" ? "Disponibile" : "In arrivo"}
                    </span>
                  </div>
                  <div className="p-8 flex flex-col flex-1">
                    <h2 className="font-serif text-xl font-semibold text-nero leading-snug group-hover:text-bordeaux transition-colors">
                      {c.title}
                    </h2>
                    <p className="mt-3 text-sm text-nero/65 leading-relaxed line-clamp-3 flex-1">{c.subtitle}</p>
                    <div className="mt-6 flex items-center gap-4 text-xs text-nero/50">
                      <span className="inline-flex items-center gap-1.5"><Layers size={13} /> {c.num_lessons} lezioni</span>
                      <span className="inline-flex items-center gap-1.5"><Clock size={13} /> {c.duration}</span>
                    </div>
                    <div className="mt-5 pt-5 border-t border-nero/10 flex items-center justify-between">
                      <span className="text-xs uppercase tracking-wider text-oliva">{c.target}</span>
                      <span className="font-serif text-bordeaux font-bold text-lg">€{c.price.toFixed(0)}</span>
                    </div>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
          {filtered.length === 0 && (
            <p className="text-center text-nero/50 py-16">Nessun corso in questa categoria al momento.</p>
          )}
        </div>
      </section>
    </div>
  );
}
